import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../../components/Hero/Hero';
import Features from '../../components/Features/Features';
import Products from '../../components/Products/Products';
import Fairs from '../../components/Fairs/Fairs';
import Certificates from '../../components/Certificates/Certificates';
import FabricDetailPage from '../fabrics/FabricDetailPage';
import FabricSinglePage from '../fabrics/FabricSinglePage';
import { Routes, Route } from 'react-router-dom';

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);

  return (
    <>
      <Hero />
      <Products />
      <Features />
      <Certificates />
      <Fairs />
      {/* Add route for fabric detail */}
      <Routes>
        <Route path="/fabric/:id" element={<FabricSinglePage />} />
      </Routes>
    </>
  );
};

export default HomePage;